export const createMorningMonitoring = {
    namespaced: true,

    state: {
        id: null,
        morningMonitoringDate: null
    },

    getters: {
        morningMonitoringDate(state) {
            return state.morningMonitoringDate;
        },

        morningMonitoringId(state) {
            return state.id;
        }
    },

    actions: {
        setEditMorningMonitoring(context, payload) {
            Vue.set(context.state, 'id', payload.id);
            Vue.set(context.state, 'morningMonitoringDate', payload.date);
        }
    }
};
